import { Link, type LinkProps } from 'react-router-dom';
import { launchMatrixTransition } from './MatrixRainTransition';

interface MatrixLinkProps extends LinkProps {
  titleForTransition?: string;
}

export default function MatrixLink({ to, titleForTransition, onClick, children, ...props }: MatrixLinkProps) {
  return (
    <Link
      to={to}
      onClick={(event) => {
        onClick?.(event);
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.altKey ||
          event.ctrlKey ||
          event.shiftKey
        ) {
          return;
        }

        if (typeof to !== 'string') return;
        if (!to.startsWith('/')) return;

        event.preventDefault();
        launchMatrixTransition({ href: to, title: titleForTransition });
      }}
      {...props}
    >
      {children}
    </Link>
  );
}
